import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

export const deviceService = {
  /**
   * توليد معرف فريد للجهاز
   */
  async getDeviceId() {
    try {
      // التحقق من وجود معرف مخزن مسبقاً لسرعة الاستجابة
      const cachedId = localStorage.getItem('raqmoon_device_id');
      if (cachedId) return cachedId;

      if (!fpPromise) {
        fpPromise = FingerprintJS.load();
      }
      
      const fp = await fpPromise;
      const result = await fp.get();
      
      // هذا المعرف (visitorId) فريد جداً بناءً على أكثر من 30 خاصية في المتصفح والجهاز
      const deviceId = result.visitorId;
      
      localStorage.setItem('raqmoon_device_id', deviceId);
      return deviceId;
    } catch (error) {
      console.error('[DeviceService] Failed to get device ID:', error);
      return 'unknown_device';
    }
  }
};
